import PillToggle from './PillToggle'

// Holding Costs spec 1.3: pill 113x26 (65 + 46 segments). Only "Monthly selected" is drawn; the
// "Total selected" chip is derived -- see README.md ("Monthly | Total toggle").
const OPTIONS = [
  { value: 'Monthly', label: 'Monthly', width: 65 },
  { value: 'Total', label: 'Total', width: 46 },
]

// `value` is the stored toggle string: the formula core reads only the literal 'Total'
// (reilm-be flip/holdingCosts.js), so anything else -- unset included -- is Monthly.
export default function MonthlyTotalToggle({ value, onChange, ariaLabel }) {
  return <PillToggle options={OPTIONS} selected={value === 'Total' ? 'Total' : 'Monthly'} onChange={onChange} ariaLabel={ariaLabel} />
}
